<template>
  <div id="app">
    <header class="header">
      <div class="header-container">
        <div class="logo">
          <router-link to="/">指标论坛</router-link>
        </div>
        <nav class="nav">
          <router-link to="/" class="nav-item">首页</router-link>
          <router-link to="/indicators" class="nav-item">指标公式</router-link>
          <router-link to="/tech-share" class="nav-item">技术分享</router-link>
          <router-link to="/forum" class="nav-item">交流论坛</router-link>
        </nav>
        <div class="user-actions">
          <template v-if="isLoggedIn">
            <router-link to="/user" class="action-btn user-center">
              <span class="user-icon">{{ userInfo?.nickname?.charAt(0) || 'U' }}</span>
              <span class="user-name">{{ userInfo?.nickname || '用户' }}</span>
            </router-link>
          </template>
          <template v-else>
            <router-link to="/login" class="action-btn">登录</router-link>
            <router-link to="/register" class="action-btn register">注册</router-link>
          </template>
        </div>
      </div>
    </header>
    <main class="main">
      <router-view />
    </main>
    <footer class="footer">
      <div class="footer-container">
        <p>© 2026 指标论坛 版权所有</p>
      </div>
    </footer>
  </div>
</template>

<script>
import userStore from './store/user'

export default {
  name: 'App',
  data() {
    return {
      userInfo: null,
      isLoggedIn: false
    }
  },
  mounted() {
    this.updateUserStatus()
  },
  watch: {
    $route() {
      this.updateUserStatus()
    }
  },
  methods: {
    updateUserStatus() {
      this.userInfo = userStore.state.userInfo
      this.isLoggedIn = userStore.state.isLoggedIn
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  background-color: #1890ff;
  color: #fff;
  padding: 0 20px;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  a {
    color: #fff;
    text-decoration: none;
  }
}

.nav {
  display: flex;
  gap: 30px;
  .nav-item {
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    &:hover {
      text-decoration: underline;
    }
  }
}

.user-actions {
  display: flex;
  gap: 15px;
  align-items: center;
  .action-btn {
    color: #fff;
    text-decoration: none;
    padding: 6px 12px;
    border-radius: 4px;
    transition: all 0.3s ease;
    &:hover {
      transform: translateY(-2px);
    }
    &.register {
      background-color: rgba(255, 255, 255, 0.2);
      &:hover {
        background-color: rgba(255, 255, 255, 0.3);
      }
    }
    &.user-center {
      display: flex;
      align-items: center;
      gap: 8px;
      background-color: rgba(255, 255, 255, 0.1);
      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    .user-icon {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.2);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
    }
    .user-name {
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.main {
  flex: 1;
  padding: 20px;
}

.footer {
  background-color: #f5f5f5;
  padding: 20px;
  text-align: center;
  color: #666;
  margin-top: auto;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-container {
    flex-wrap: wrap;
    height: auto;
    padding: 10px 0;
  }
  
  .nav {
    order: 3;
    width: 100%;
    justify-content: center;
    margin-top: 10px;
    gap: 20px;
  }
  
  .user-actions {
    order: 2;
  }
  
  .main {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .logo {
    font-size: 20px;
  }
  
  .nav {
    gap: 15px;
    .nav-item {
      font-size: 14px;
    }
  }
  
  .user-actions {
    gap: 10px;
    .action-btn {
      padding: 4px 8px;
      font-size: 14px;
    }
  }
}
</style>
